export default __webpack_public_path__ + "static/media/detail-play.3eb4dc64.svg";